import React from 'react';
import BlockIcon from '@mui/icons-material/Block';
import { useShowContext } from 'framework/show';
import useVendorService from '../../useVendorService';
import { VendorDto } from '../../types';
import TerminateAgreementForm from '../../createupdate/Create/TerminateAgreementForm';
import AgreementActionButton from './AgreementActionButton';
import { useAgreementPermissions, AGREEMENT_PERMISSIONS } from './AgreementPermissionsContext';

interface TerminateAgreementButtonProps {
  vendorData?: VendorDto;
}

const TerminateAgreementButton = ({ vendorData }: TerminateAgreementButtonProps) => {
  const { terminateAgreement } = useVendorService();
  const { data: agreement } = useShowContext();
  const { hasPermission } = useAgreementPermissions();

  const canTerminate = agreement?.status === 'ACTIVE' && hasPermission(AGREEMENT_PERMISSIONS.TERMINATE);

  const getValidationSchema = () =>
    Promise.resolve({
      endDate: { type: 'date', required: true },
    });

  const handleSubmit = async (agreementId: string, values: any) => {
    return terminateAgreement(agreementId, { endDate: values.endDate as string });
  };

  return (
    <AgreementActionButton
      vendorData={vendorData}
      icon={<BlockIcon />}
      color="error"
      formTitle="Terminate agreement"
      tooltip="Terminate agreement"
      canPerformAction={canTerminate}
      onSubmit={handleSubmit}
      getValidationSchema={getValidationSchema}
      initialData={{}}
    >
      <TerminateAgreementForm />
    </AgreementActionButton>
  );
};

export default TerminateAgreementButton;
